import {
  manualsFromForm,
  manualsToFileList,
  parseManuals
} from '@/utils/pageParams/domainBrand.js'
import { reloadSiteBrand } from '@/utils/siteBrand'

function normalizeHost(raw) {
  let value = (raw || '').trim().toLowerCase()
  if (value.startsWith('http://')) value = value.slice(7)
  else if (value.startsWith('https://')) value = value.slice(8)
  const slash = value.indexOf('/')
  if (slash >= 0) value = value.slice(0, slash)
  const colon = value.indexOf(':')
  if (colon >= 0) value = value.slice(0, colon)
  if (value.startsWith('www.')) value = value.slice(4)
  return value
}

function pickLogo(data, key) {
  const lists = (data && data.fileLists && data.fileLists[key]) || []
  if (lists.length && lists[0] && lists[0].url) {
    return lists[0].url
  }
  const value = (data && data[key]) || ''
  return typeof value === 'string' ? value : ''
}

function enrichRow(row, rootState) {
  const loginLogo = row.loginLogo || ''
  const homeLogo = row.homeLogo || ''
  const manuals = manualsToFileList(
    row.userManuals,
    rootState.baseURL,
    rootState.uploadfile
  )
  return Object.assign({}, row, {
    useSameLogo: !homeLogo || homeLogo === loginLogo,
    loginLogo: loginLogo,
    homeLogo: homeLogo,
    fileLists: {
      userManuals: manuals,
      loginLogo: loginLogo
        ? [
            {
              name: 'loginLogo.png',
              url: loginLogo,
              uid: 'loginLogo',
              status: 'success'
            }
          ]
        : [],
      homeLogo:
        homeLogo && homeLogo !== loginLogo
          ? [
              {
                name: 'homeLogo.png',
                url: homeLogo,
                uid: 'homeLogo',
                status: 'success'
              }
            ]
          : []
    }
  })
}

function buildPayload(data) {
  const host = normalizeHost(data.domainHost)
  const useSameLogo = !!data.useSameLogo
  const loginLogo = pickLogo(data, 'loginLogo')
  const homeLogo = useSameLogo ? '' : pickLogo(data, 'homeLogo')
  const manuals = manualsFromForm(data)
  return {
    uid: data.uid || '',
    domainHost: host,
    fullName: (data.fullName || '').trim(),
    shortName: (data.shortName || '').trim(),
    intro: data.intro || '',
    loginLogo: loginLogo || '',
    homeLogo: homeLogo || '',
    userManuals: JSON.stringify(manuals)
  }
}

export default {
  namespaced: true,
  state: {
    domainBrandRows: []
  },
  actions: {
    async getDomainBrandList({ dispatch, commit, rootState }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/temp/domainbrand'
        },
        { root: true }
      )
      const rows =
        res && res.code === 200 && Array.isArray(res.data) ? res.data : []
      const enriched = rows.map((row) => enrichRow(row, rootState))
      commit(
        'baseSet',
        { module: 'domainBrand', key: 'domainBrandRows', value: enriched },
        { root: true }
      )
      return res
    },
    async addDomainBrand({ dispatch }, data) {
      const payload = buildPayload(data || {})
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/temp/domainbrand',
          data: payload,
          msg: true
        },
        { root: true }
      )
      if (res && res.code === 200) {
        await reloadSiteBrand()
      }
      return res
    },
    async editDomainBrand({ dispatch }, data) {
      const payload = buildPayload(data || {})
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/domainbrand',
          data: payload,
          msg: true
        },
        { root: true }
      )
      if (res && res.code === 200) {
        await reloadSiteBrand()
      }
      return res
    },
    async deleteDomainBrand({ dispatch }, data) {
      const uid =
        data && typeof data === 'object'
          ? data.uid || (Array.isArray(data) ? data[0] && data[0].uid : '')
          : data
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/temp/domainbrand',
          data: { uid: uid },
          msg: true
        },
        { root: true }
      )
      if (res && res.code === 200) {
        await reloadSiteBrand()
      }
      return res
    }
  }
}

export { normalizeHost, parseManuals }
